import { render } from "./App.vue?vue&type=template&id=3782342e&scoped=true"
import script from "./App.vue?vue&type=script&lang=js"
export * from "./App.vue?vue&type=script&lang=js"

import "./App.vue?vue&type=style&index=0&id=3782342e&lang=scss&scoped=true"
import "./App.vue?vue&type=style&index=1&id=3782342e&lang=scss"

import exportComponent from "D:\\Project\\website-shuziyun\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3782342e"]])

export default __exports__